<template>
  <div>
    <label v-if="label" class="block text-sm font-medium text-gray-700 dark:text-gray-100">{{ label }}</label>
    <input ref="fileInput" type="file" multiple :accept="accept" @change="onChange"
      class="mt-1 block text-sm text-gray-700 dark:text-gray-100" />
    <ul v-if="modelValue.length" class="mt-2 space-y-1">
      <li v-for="(file, index) in modelValue" :key="index"
        class="flex items-center justify-between rounded-md bg-gray-100 dark:bg-gray-700 px-3 py-1 text-sm text-gray-800 dark:text-gray-100">
        <span class="truncate mr-3">{{ file.name }}</span>
        <button type="button" @click="removeFile(index)" :title="`Remove ${file.name}`" aria-label="Remove file"
          class="ml-2 shrink-0 text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300 font-bold text-lg leading-none">
          &times;
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'FileUploadList',
  props: {
    modelValue: { type: Array, default: () => [] },
    label: { type: String, default: '' },
    accept: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  methods: {
    onChange(event) {
      const picked = Array.from(event.target.files || []);
      if (picked.length) {
        const merged = [...this.modelValue];
        picked.forEach(f => {
          if (!merged.some(e => e.name === f.name && e.size === f.size)) {
            merged.push(f);
          }
        });
        this.$emit('update:modelValue', merged);
      }
      event.target.value = '';
    },
    removeFile(index) {
      const next = this.modelValue.slice();
      next.splice(index, 1);
      this.$emit('update:modelValue', next);
    },
  },
};
</script>
